import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbPopover,
} from '@ng-bootstrap/ng-bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { ToastrModule } from 'ngx-toastr';

import { CustomNgbDateAdapter, CustomNgbDateFormatter } from './services';
import { TmsFormlyConfig } from './formly-config';
import { DecimalValuePipe } from './pipes';
import { ReloadRouteReuseStrategy } from './helpers';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    AgGridModule,
    Ng2GoogleChartsModule,
    NgbDropdownModule,
    NgbDatepickerModule,
    NgbNavModule,
    NgSelectModule,
    RouterModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot(TmsFormlyConfig),
    ToastrModule.forRoot({ positionClass: 'toast-bottom-center' }),
    NgbPopover,
    DecimalValuePipe,
  ],
  exports: [
    DecimalValuePipe,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    Ng2GoogleChartsModule,
    FormlyModule,
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    DecimalValuePipe,
    DecimalPipe,
    { provide: NgbDateParserFormatter, useClass: CustomNgbDateFormatter },
    { provide: NgbDateAdapter, useClass: CustomNgbDateAdapter },
    { provide: RouteReuseStrategy, useClass: ReloadRouteReuseStrategy },
  ],
})
export class TmsLibModule {}
